class Clicky {
    private constructor() {}

    private static window = window as Window & { 
        clicky?: { 
            log: (path: string, title?: string | null, type?: string | null) => void; 
            goal: (id: string, revenue?: number | null) => void 
        } 
    };

    public static log(title: string | null = null, type: string | null = null): void {
        if (this.window.clicky) {
            this.window.clicky.log(this.window.location.pathname, title, type);
        }
    }

    public static goal(id: string, revenue: number | null = null): void {
        if (this.window.clicky) {
            this.window.clicky.goal(id, revenue);
        }
    }
}

export default Clicky; 